import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

import Button from '../Button'
import Icon from '../Icon'

import localization from './localization'
import navigationLocalization from '../../localization/navigation'
import commonLocalization from '../../localization/common'

import styles from './Navigation.module.styl'

class Navigation extends Component {
  static propTypes = {
    language: PropTypes.string.isRequired,
    setLanguage: PropTypes.func.isRequired,
  }

  state = {
    navigationOpen: false
  }

  _toggleNavigation = (state) => {
    this.setState({ navigationOpen: state || !this.state.navigationOpen })
  }

  _renderNavItems = () => {
    const { language } = this.props

    return Object.keys(navigationLocalization).map(page => (
      <Link
        key={navigationLocalization[page][language]}
        to={`/${navigationLocalization[page][language].toLowerCase().replace(' ', '')}`}
        className={styles.menuItem}
        activeClassName={styles.menuItemActive}
        onClick={() => { this._toggleNavigation(false) }}
      >
        {navigationLocalization[page][language]}
      </Link>
    ))
  }

  render() {
    const { navigationOpen } = this.state
    const { language } = this.props

    return (
      <React.Fragment>
        <button
          className={[styles.navToggle, navigationOpen ? styles.navigationOpen : null].join(' ')}
          onClick={() => { this._toggleNavigation() }}
        >
          <Icon size={24} type={navigationOpen ? 'close' : 'nav'} />
        </button>

        <div className={[styles.mobileWrapper, navigationOpen ? styles.navigationOpen : null].join(' ')}>
          <nav className={styles.navigation}>
            <div className={styles.menu}>
              <Link
                activeClassName={styles.menuItemActive}
                className={styles.menuItem}
                exact
                onClick={() => { this._toggleNavigation(false) }}
                to="/"
              >
                Home
              </Link>
              {this._renderNavItems()}
            </div>

            <div className={styles.actions}>
              <button
                className={[
                styles.actionsItem,
                language === 'nl' ? styles.actionsItemActive : null
              ].join(' ')}
                onClick={() => { this.props.setLanguage('nl') }}
              >
                NL
              </button>

              <button
                className={[
                styles.actionsItem,
                language === 'de' ? styles.actionsItemActive : null
              ].join(' ')}
                onClick={() => { this.props.setLanguage('de') }}
              >
                DE
              </button>

              <button
                className={[
                styles.actionsItem,
                language === 'en' ? styles.actionsItemActive : null
              ].join(' ')}
                onClick={() => { this.props.setLanguage('en') }}
              >
                EN
              </button>
            </div>

            <Button
              inline
              type="anchor"
              to={commonLocalization[language].bookUrl}
              target="_blank"
            >
              {localization[language].actionBook} »
            </Button>
          </nav>
        </div>
      </React.Fragment>
    )
  }
}

export default Navigation




// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js